<template>
    <div class="sdr-box contact-box">
        <h4
            style="color: #944579; font-weight:700;"
            v-html="importantinfosheader[getCurrentLocale]"
        ></h4>
        <p v-html="importantinfostext[getCurrentLocale]"></p>
    </div>
</template>

<script>
import { mapGetters } from 'vuex';


export default {

    /* >>> *************************************************************** / /* Data */
    data: function() {
        return {
            importantinfosheader: {
                en: 'Take off with SUNDAIR!<br /><br />Flights Berlin/BER – Beirut - Berlin/BER',
                de: 'Heben Sie mit SUNDAIR ab!<br /><br />Flüge Berlin/BER – Beirut - Berlin/BER',
            },
            importantinfostext: {
                en: 'Fly with us Fliegen Sie mit uns jeweils freitags und montags on Fridays and Mondays at favourable ticket prices and baggage conditions.<br /><br /> Among other things, infants up to the age of 2 travel free of charge and receive 10 kg free baggage allowance.<br /><br /> Excess baggage charges: with online reservation 10 EUR per kg; at check-in 15 EUR per kg.<br /><br /> For detailed information, please contact our customer service team on 030 53 6767 91 tel.',
                de: 'Fliegen Sie mit uns jeweils freitags und montags zu günstigen Ticketpreisen und Gepäckkonditionen.<br /><br /><b>Kleinkinder</b> reisen bis zum vollendeten 2. Lebensjahr <b>kostenlos</b> und erhalten <br /><b>10 kg Freigepäck</b>.<br /><br />Übergepäck-Gebühren: bei Online-Reservierung <b>10 EUR je kg</b>; am Check-in <b>15 EUR je kg</b>.<br /><br />Rollstuhl-Anmeldungen: bitte spätestens <b>2 Tage vor Flug</b> per E-Mail an <a href="mailto:kundenservice@sundair.com">kundenservice@sundair.com</a><br /><br />Detaillierte Informationen erhalten Sie von unserem Kundenservice-Team unter<br />Tel. <b>030 53 6767 91</b>.',
            },
            // currentLocale: 'de',
        };
    }, // eof data()
    /* <<< ****************************************************************/




    /* >>> *************************************************************** / /* Computed */
    computed: {

        ...mapGetters(['getCurrentLocale']),

    }, // eof computed{}
    /* <<< ****************************************************************/

};
</script>


// WEBPACK FOOTER //
// src/components/shared/sidebar/ImportantInfos3Box.vue